import { Link } from 'react-router-dom';
import { getComicsByCategory, categories } from '@/mocks/comics';
import ComicCard from '@/components/feature/ComicCard';

export default function LatestUpdates() {
  const latestComics = getComicsByCategory('all').sort((a, b) =>
    new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()
  ).slice(0, 8);

  const categoryMap: Record<string, string> = {};
  categories.forEach((c) => {
    categoryMap[c.slug] = c.name;
  });

  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">
              最新<strong className="text-primary-500">更新</strong>
            </h2>
            <p className="mt-1 text-sm text-foreground-500">不错过任何一部精彩作品</p>
          </div>
          <Link
            to="/category/all"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            更多 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
          {latestComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}